import { useEffect } from 'react';
import { DISCORD_COMMUNITY_URL } from '../lib/community-redirects';

export function DiscordRedirectPage() {
  useEffect(() => {
    window.location.replace(DISCORD_COMMUNITY_URL);
  }, []);

  return (
    <main className="flex min-h-[100dvh] items-center justify-center bg-background p-6 text-foreground">
      <section className="max-w-sm rounded-2xl border border-border bg-card p-6 text-center shadow-sm">
        <h1 className="text-lg font-semibold">Opening Discord</h1>
        <p className="mt-2 text-sm text-muted-foreground">
          If Discord does not open automatically, use the community invite link
          below.
        </p>
        <a
          className="mt-4 inline-flex rounded-lg bg-primary px-4 py-2 text-sm font-medium text-primary-foreground"
          href={DISCORD_COMMUNITY_URL}
          rel="noreferrer"
        >
          Open Discord
        </a>
      </section>
    </main>
  );
}
